/**
 * @author HungNS
 */
/* eslint-disable no-unused-vars */
import MobileDetect from "mobile-detect";

const BrowserPlugin = {
  install(Vue, options) {
    const { prototype } = Vue;
    let isWebviewIOS = false;
    const userAgent = window.navigator.userAgent;
    const mobileDetect = new MobileDetect(userAgent);
    const mobileMode = mobileDetect.mobile();
    const tabletMode = mobileDetect.tablet();
    const isAndroid = mobileDetect.is("AndroidOS");
    const isSafari = mobileDetect.is("Safari");
    const isWebview = userAgent.indexOf("Nextop.WebKit") != -1;
    const isNoldor = userAgent.indexOf("Nextop.WebKit.Noldor") !== -1;
    const isEreborSc = !isNoldor ? userAgent.indexOf("Nextop.WebKit") !== -1 : false;
    const isIOS = mobileDetect.is("iOS");
    const IOSVersion = mobileDetect.version('iOS');
    if (isIOS && isWebview) {
      isWebviewIOS = true;
    }

    let newPrototype = {
      IOSVersion,
      isWebviewIOS,
      isIOS,
      isWebview,
      isNoldor,
      isEreborSc,
      mobileMode,
      tabletMode,
      isAndroid,
      isSafari,
    };
    Object.assign(prototype, newPrototype);
    Vue.prototype = prototype;
  },
};

export default BrowserPlugin;
